import { IconButton } from '@mui/material';
import { VyIcon } from '@weft/icons';
import type { CloseButtonProps } from 'react-toastify/dist/components';

export const VyToastCloseButton: React.FC<CloseButtonProps> = ({ closeToast }: CloseButtonProps) => (
  <IconButton onClick={closeToast}>
    <VyIcon
      icon="CloseBig"
      color='#0D1B27DE'
    />
  </IconButton>
);